module.exports = __webpack_public_path__ + "img/117.dd7b9973.jpg";